import { render, staticRenderFns } from "./streamMedia.vue?vue&type=template&id=726b21f4&scoped=true&"
var script = {}
import style0 from "./streamMedia.vue?vue&type=style&index=0&id=726b21f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726b21f4",
  null
  
)

export default component.exports